import { entityConstants } from '../constants/entity.constants'

export function entityReducer(
  state = { weekFilter: 7, updateRequest: null },
  action
) {
  switch (action.type) {
    case entityConstants.WEEK_FILTER:
      return Object.assign({}, state, {
        weekFilter: action.weekFilter
      })
    case entityConstants.REQUEST_UPDATE:
      return Object.assign({}, state, {
        updateRequest: action.updateRequest
      })
    case entityConstants.REQUEST_UPDATE_PENDING:
      return Object.assign({}, state, {
        updateRequest: null
      })
    case entityConstants.REQUEST_DIALOG_CLOSE:
      return Object.assign({}, state, {
        updateRequest: null
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/entity.reducer.js